module.exports = __webpack_public_path__ + "img/2021_2_4_cat_many_eyes.ac96df13.jpg";